import { render, staticRenderFns } from "./DataReview.vue?vue&type=template&id=38af5560&scoped=true"
import script from "./DataReview.vue?vue&type=script&lang=js"
export * from "./DataReview.vue?vue&type=script&lang=js"
import style0 from "./DataReview.vue?vue&type=style&index=0&id=38af5560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af5560",
  null
  
)

export default component.exports